import React from 'react'
import styled from 'styled-components'
import { DEFAULT_CONFIG } from '../../constants/styledComponents'
import { getTypographyDefaultConfig } from '../../utils/typography.util'

const StyledH2 = styled.h2.withConfig(DEFAULT_CONFIG)(props => ({
    ...getTypographyDefaultConfig(props),
    fontSize: 24,
}))

const H2 = props => (
    <StyledH2
        {...props}
        style={
            props.onClick ? { cursor: 'pointer', ...props.style } : props.style
        }
    >
        {props.children}
    </StyledH2>
)

export default H2
